import service from '@/services/inventario/descuento'

export const namespaced = true

const descuento = {
  emisor: { _id: '' },
  naturalezaDescuento: '',
  porcentajeDescuento: 0,
  montoDescuento: 0
}

const getDefaultState = () => ({
  descuento,

  list: [],
  listType: [],
  pageInfo: {},
  currentRow: null,

  saved: 'null',
  isListening: false
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_DESCUENTO: (state, obj) => {
    state.descuento = obj
    state.saved = true
  },
  SET_LIST: (state, obj) => {
    state.list = [...new Set([...state.list.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.listType = state.list
    state.pageInfo = obj.pageInfo
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    // lista para producto
    state.listType = state.list
    // TODO: actualiza campos por suscripcion
    // else {
    //   nObj.x = obj.x
    // }
  },
  DELETE_LIST: (state, obj) => {
    state.list = state.list.filter(e => e._id !== obj._id)
    state.listType = state.list
  },
  RESET: state => {
    state.descuento = { ...descuento }
  },
  SAVE_CHANGES: (state, obj) => {
    state.descuento = obj
    state.saved = false
  },
  LIST: (state, objs) => (state.listType = objs)
}

export const actions = {
  create: async ({ commit, rootGetters }, item) =>
    service
      .create({
        ...item,
        emisor: { _id: await rootGetters['facturacion/emisorStore/get_Id'] },
        montoDescuento: Number(parseFloat(item.montoDescuento).toFixed(5)),
        porcentajeDescuento: Number(parseFloat(item.porcentajeDescuento).toFixed(3))
      })
      .then(result => {
        commit('UPDATE_LIST', { ...item, _id: result._id })

        return true
      }),

  readById: ({ state, commit }, { _id, refresh = false }) => {
    if (refresh) return service.readById(_id).then(result => commit('SET_DESCUENTO', result))

    return commit(
      'SET_DESCUENTO',
      state.list.find(e => e._id === _id)
    )
  },

  resetList: ({ state }) => {
    state.list = []
    state.pageInfo = {}
  },

  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, { cache = true, restart = false, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetList')
    if (state.list.length && cache) {
      console.log('Descuentos from cache ⏩')
      return state.list
    }

    console.log('Descuentos from Db 😅')
    // materia prima, tipoProducto === '01'
    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id'], state.pageInfo.nextPageCursor, limit, filter).then(result => {
      commit('SET_LIST', result)
      if (!state.isListening) {
        state.isListening = true
        // TODO: Subs
        // dispatch('subscriptionNewMateriaPrima')
      }
    })
  },

  listType: ({ commit, state, rootGetters }) => {
    if (state.listType.length > 0) return state.listType

    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id']).then(result => commit('LIST', result.feed))
  },

  delete: ({ commit }, { items }) =>
    service.delete(items).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', i)
      })
      return result
    }),

  // TODO: subs
  // subscriptionNewMateriaPrima: ({ commit, rootGetters }) =>
  //   service.subscriptionNewMateriaPrima(rootGetters['facturacion/emisorStore/get_Id'], result => commit('UPDATE_FACTURAS', result)),

  saveChanges: ({ commit }, item) => commit('SAVE_CHANGES', item)
}

export const getters = {
  get: state => _id => state.list.find(e => e._id === _id)
}
